module.exports = __webpack_public_path__ + "img/1_012.6d4a8c1c.jpg";